module.exports = __webpack_public_path__ + "media/images/top/seminars/seminar_ogp-cc2f3325e7c2b5d79b16a0d29f6828a6.png";